import { AppointmentRequestPriorityFeedQuery } from './appointment_request_priority_feed_query';
import { AppointmentPriorityFeedQuery } from './appointments_priority_feed_query';
import { EventPriorityFeedQuery } from './events_priority_feed_query';
import { ToDoPriorityFeedQuery } from './to_do_priority_feed_query';

angular
  .module('data-ng-todos')
  .service('ngToDoPriorityFeedQuery', ToDoPriorityFeedQuery)
  .service('ngEventPriorityFeedQuery', EventPriorityFeedQuery)
  .service('ngAppointmentPriorityFeedQuery', AppointmentPriorityFeedQuery)
  .service('ngAppointmentRequestPriorityFeedQuery', AppointmentRequestPriorityFeedQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/queries/data_ng_path_queries_module.ts